import { useFormikContext } from 'formik';

import { QRCode } from '../../../Components/Form';
import DefaultImage from '../Assets/Images/default.png';

const Preview = ({
  context,
  loading,
  imageLoading,
  image,
  removeItem,
  signatureLoading,
}) => {
  const { values } = useFormikContext();
  return (
    <div className='col-12 my-5 border border-dark rounded py-4'>
      <div className='d-flex flex-row justify-content-start border-bottom border-dark pb-2'>
        <i className='far fa-search f-16 text-dark'></i>
        <h1 className='text-dark f-14 mx-2 my-0'>پیش نمایش تغیرات</h1>
      </div>
      <div className='d-flex flex-column justify-content-center align-items-center my-3'>
        <div
          className='border border-dark rounded overflow-hidden'
          style={{
            position: 'relative',
            width: values?.width + 'cm',
            height: values?.height + 'cm',
          }}
        >
          {imageLoading ? null : (
            <img
              src={image}
              alt=''
              style={{
                width: values?.width + 'cm',
                height: values?.height + 'cm',
              }}
            />
          )}
          {signatureLoading
            ? null
            : context.signature?.background_image !== undefined && (
                <>
                  <img
                    src={context.signature?.background_image}
                    alt=''
                    style={{
                      position: 'absolute',
                      width: context.signature?.width + 'px',
                      height: context.signature?.height + 'px',
                      top: context.signature?.top + 'px',
                      right: context.signature?.right + 'px',
                      left: context.signature?.left + 'px',
                      bottom: context.signature?.bottom + 'px',
                    }}
                  />
                  <i
                    className='fad fa-minus-hexagon f-16 text-danger c-pointer'
                    style={{
                      width: '40px',
                      height: '40px',
                      position: 'absolute',
                      top: context.signature?.top + 'px',
                      bottom: context.signature?.bottom + 'px',
                      right: context.signature?.right - 14 + 'px',
                      left: context.signature?.left + 'px',
                      cursor: 'pointer',
                      zIndex: '9999999999',
                    }}
                    onClick={() => {}}
                  ></i>
                </>
              )}
          {loading ? null : (
            <>
              {context.fields?.map((field) => (
                <>
                  {field?.type === 'string' ||
                  field?.type === 'date' ||
                  field?.type === 'province' ? (
                    <>
                      <i
                        className='fad fa-minus-hexagon f-16 text-danger c-pointer'
                        style={{
                          width: '40px',
                          height: '40px',
                          position: 'absolute',
                          top: field?.top + 'px',
                          bottom: field?.bottom + 'px',
                          right: field?.right - 15 + 'px',
                          left: field?.left + 'px',
                          cursor: 'pointer',
                          zIndex: '9999999999',
                        }}
                        onClick={() => removeItem(field?.id)}
                      ></i>

                      <span
                        className='text-dark'
                        style={{
                          fontSize: values.font_size + 'px',
                          position: 'absolute',
                          top: field?.top + 'px',
                          bottom: field?.bottom + 'px',
                          right: field?.right + 'px',
                          left: field?.left + 'px',
                          fontFamily: field?.bold ? 'iranBold' : 'iransans',
                        }}
                      >
                        {field?.title}
                      </span>
                    </>
                  ) : field?.type === 'QRCode' ? (
                    <>
                      <div
                        className='align-items-center'
                        style={{
                          width: field?.width != undefined ? field?.width : 100,
                          height:
                            field?.height != undefined ? field?.height : 100,
                          position: 'absolute',
                          top: field?.top + 'px',
                          bottom: field?.bottom + 'px',
                          right: field?.right + 'px',
                          left: field?.left + 'px',
                        }}
                      >
                        <QRCode
                          width={field?.width != undefined ? field?.width : 100}
                          height={
                            field?.height != undefined ? field?.height : 100
                          }
                          value={field?.value}
                        />
                      </div>
                      <i
                        className='fad fa-minus-hexagon f-16 text-danger c-pointer'
                        style={{
                          width: '40px',
                          height: '40px',
                          position: 'absolute',
                          top: field?.top + 'px',
                          bottom: field?.bottom + 'px',
                          right: field?.right - 15 + 'px',
                          left: field?.left + 'px',
                          cursor: 'pointer',
                          zIndex: '9999999999',
                        }}
                        onClick={() => removeItem(field?.id)}
                      ></i>
                    </>
                  ) : field?.type === 'image' ? (
                    <>
                      <div
                        style={{
                          position: 'absolute',
                          top: field?.top + 'px',
                          right: field?.right + 'px',
                          left: field?.left + 'px',
                          bottom: field?.bottom + 'px',
                          width: field?.width + 'px',
                          height: field?.height + 'px',
                        }}
                      >
                        <img
                          className='font-weight-bold w-100 h-100 rounded'
                          style={{
                            backgroundSize: 'contain',
                          }}
                          src={DefaultImage}
                          alt=''
                        />
                      </div>
                      <i
                        className='fad fa-minus-hexagon f-16 text-danger c-pointer'
                        style={{
                          width: '40px',
                          height: '40px',
                          position: 'absolute',
                          top: field?.top + 'px',
                          bottom: field?.bottom + 'px',
                          right: field?.right - 15 + 'px',
                          left: field?.left + 'px',
                          cursor: 'pointer',
                          zIndex: '9999999999',
                        }}
                        onClick={() => removeItem(field?.id)}
                      ></i>
                    </>
                  ) : null}
                </>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Preview;
